import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home/home'
import detailsPage from '@/views/details/detailsPage'
import caseDetailsPage from "../views/case/caseDetailsPage"

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            name: 'home',
            component: home
        },
        {
            path: '/details',
            name: 'details',
            component: detailsPage
        },
        {
            path: '/case',
            name: 'caseDetails',
            component: caseDetailsPage
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js